<template>
  <div>
    <a-tooltip placement="top" title="Editar">
      <a-button type="link" @click="handleClick">
        <template #icon>
          <EditOutlined
            :style="{
              color: queue.status === 1 ? '#1890FF' : '#BFBFBF',
              fontSize: '17.5px',
            }"
          />
        </template>
      </a-button>
    </a-tooltip>
    <queues-editor-modal
      v-if="modal"
      :value="modal"
      :key="queue.id + '-edit'"
      :isActive="true"
      :queue="queue"
      @update="$emit('update')"
      @onClose="closeModal"
    />
  </div>
</template>

<script>
import QueuesEditorModal from "@/app/queues/components/modals/QueuesEditorModal.vue";
import { mapQueue } from "@/app/queues/utils/helpers";
import { defineComponent } from "vue";
import { EditOutlined } from "@ant-design/icons-vue";

import { QueuesEvent } from "@/app/queues/domain/events";
import EventBus from "@/app/shared/utils/eventBus";

export default defineComponent({
  components: {
    QueuesEditorModal,
    EditOutlined,
  },
  props: {
    queue: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    closeModal() {
      this.modal = false;
    },
    async setQueueToStore() {
      console.log(this.queue, 'queue')
      const queue = mapQueue(this.queue);
      await this.$store.dispatch("setQueueProperties", queue);
    },
    async handleClick() {
      if (this.queue.status == 1) {
        await this.setQueueToStore();
        this.modal = true;
        EventBus.$emit(QueuesEvent.QUEUE_MODAL_EDIT_OPENED);
      }
    },
  },
});
</script>
